import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import qs from 'qs';
import {
  onRequest,
  onErrorRequest,
  onResponse,
  onErrorResponse,
} from "./axiosInterceptor";

class AxiosService {
  private static instance: AxiosService;
  private axiosInstance: AxiosInstance;

  private constructor() {
    this.axiosInstance = axios.create({
      withCredentials: true,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
      }
    });

    this.axiosInstance.interceptors.request.use(onRequest, onErrorRequest);
    this.axiosInstance.interceptors.response.use(onResponse, onErrorResponse);
  }

  public static getInstance(): AxiosService {
    if (!AxiosService.instance) {
      AxiosService.instance = new AxiosService();
    }
    return AxiosService.instance;
  }

  getAxiosInstance(): AxiosInstance {
    return this.axiosInstance;
  }
}

export default AxiosService.getInstance();
